import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  MenuItem,
} from "@material-ui/core";
import { Environment } from "../_generated";
import { Controller, useForm } from "react-hook-form";

export default function EnvironmentMoveDialog(props: {
  open: boolean;
  environment?: Environment;
  onCancel: () => any;
  onConfirm: () => any;
}) {
  const { control } = useForm({
    shouldUnregister: true,
  });

  const cloudAccounts = [
    "AWS - default account",
    "GCP - default account",
    "Azure - default account",
  ];

  return (
    <Dialog open={props.open}>
      <DialogTitle>Move Environment: {props.environment?.name}</DialogTitle>
      <DialogContent>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="account"
                defaultValue={cloudAccounts[0]}
                render={({ onChange, value, ref }) => (
                  <TextField
                    select
                    label="Account to move to"
                    variant="outlined"
                    value={value}
                    onChange={onChange}
                    inputRef={ref}
                    fullWidth
                  >
                    {cloudAccounts.map((account) => (
                      <MenuItem value={account} key={account}>
                        {account}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={props.onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
